import { render, staticRenderFns } from "./InterconsultaFormulario.vue?vue&type=template&id=7da2f828&scoped=true"
import script from "./InterconsultaFormulario.vue?vue&type=script&lang=js"
export * from "./InterconsultaFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da2f828",
  null
  
)

export default component.exports